import React from 'react'

const MyLocation = () => {
  return (
    <div className="myLocation">
   <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d145293.08504050953!2d-110.44633086587793!3d24.109531148363658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86afd2def5da1057%3A0x4875d2e8c0f1a3b6!2sLa%20Paz%2C%20B.C.S.!5e0!3m2!1ses!2smx!4v1768024827293!5m2!1ses!2smx"
        width="100%"
        height="400"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        scrolling="yes"
      ></iframe>
  </div>
  )
}

export default MyLocation

  